import {map as _map} from "lodash";
import * as React from "react";
import { ORION_IMG_URL } from "../../../utils/AppConstants";

export interface PatientNoteSetPlanPDFProps {
    id: string;
    planItem: any;
}

const PatientNoteSetPlanPDFTemplate: React.StatelessComponent<PatientNoteSetPlanPDFProps> = (props: PatientNoteSetPlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemsToIterate = planItem[id];
    return (
        <div id={id} className={`prescription-grid-row external-row`}>
            <div className="prescription-card-content">
                <div className={`${id}-header brandon-bold`}><img src={ORION_IMG_URL + "icons/notes-header-icon.svg"} className={"header-icon"} /> NOTES</div>
                <ul id={`${id}-subsection`} className="prescription-description">
                    {
                        _map(itemsToIterate, (noteItem, index) => {
                            return (
                                <div>
                                    <li className={"patientNote-item"}>{noteItem.patientNotes}</li>
                                </div>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
}

export default PatientNoteSetPlanPDFTemplate;